// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppCleanup } from '../models';
import { UtilityHelper } from '../helpers';

@Injectable({
	providedIn: 'root',
})
export class DCGService extends AppCleanup {
	domain: string = window.location.hostname;

	constructor(private http: HttpClient) {
		super();
	}

	getConnectionStatus() {
		return this.http.get<any>(`https://${this.domain}:5003/api/Status`);
	}

	getOutputAdapterStatus(): Observable<OutputStatusObject[]> {
		return this.http.get<OutputStatusObject[]>(`https://${this.domain}:5003/api/status/outputadapters`);
	}

	unitCommands(command: string, unitGuid: string) {
		let commandModel: UnitCommandModel = {
			command: command,
			target: unitGuid,
		};

		return this.http.post<UnitCommandModel>(`https://${this.domain}:5003/api/datasources/commands`, commandModel);
	}

	startAllUnits() {
		return this.unitCommands(CommandType.START, UtilityHelper.emptyGuid());
	}

	restartAllUnits() {
		return this.unitCommands(CommandType.RESTART, UtilityHelper.emptyGuid());
	}

	stopAllUnits() {
		return this.unitCommands(CommandType.STOP, UtilityHelper.emptyGuid());
	}

	startUnit(unitGuid: string) {
		return this.unitCommands(CommandType.START, unitGuid);
	}

	restartUnit(unitGuid: string) {
		return this.unitCommands(CommandType.RESTART, unitGuid);
	}

	removeUnit(unitGuid: string) {
		return this.unitCommands(CommandType.REMOVE, unitGuid);
	}

	forceRestartUnit(unitGuid: string) {
		return this.unitCommands(CommandType.FORCE_RESTART, unitGuid);
	}

	stopUnit(unitGuid: string) {
		return this.unitCommands(CommandType.STOP, unitGuid);
	}

	matchTemporaryUnit(matchTemporaryUnitObject: MatchTemporaryUnitModel) {
		return this.http.post<MatchTemporaryUnitModel>(`https://${this.domain}:5003/api/unit/matchtemporaryunit`, matchTemporaryUnitObject);
	}

	outputAdapterCommands(command: string, outputConfigId: number, unitGuid: string) {
		let commandModel: OutputCommandModel = {
			command: command,
			targetUnit: unitGuid,
			targetOutputConfig: Number(outputConfigId),
		};

		return this.http.post<OutputCommandModel>(`https://${this.domain}:5003/api/dataoutputadapter/commands`, commandModel);
	}

	restartAdapter(unitGuid: string, outputConfigId: number) {
		return this.outputAdapterCommands(CommandType.RESTART,outputConfigId, unitGuid, );
	}

	forceRestartAdapter(unitGuid: string, outputConfigId: number) {
		return this.outputAdapterCommands(CommandType.FORCE_RESTART,outputConfigId, unitGuid);
	}

	stopAdapter(unitGuid: string, outputConfigId: number) {
		return this.outputAdapterCommands(CommandType.STOP,outputConfigId, unitGuid);
	}
}

export class UnitCommandModel {
	command: string;
	target: string;
}

export class OutputCommandModel {
	command: string;
	targetUnit: string;
	targetOutputConfig: number;
}

export enum CommandType {
	START = 'start',
	RESTART = 'restart',
	STOP = 'stop',
	FORCE_RESTART = 'forcerestart',
	REMOVE = 'remove',
}

export class MatchTemporaryUnitModel {
	temporaryUnitId: number;
	existingUnitId: number;
}

export class OutputStatusObject {
	outputAdapter: OutputAdapterObject;
	status: string;
}

export class OutputAdapterObject {
	id: number;
	unitId: number;
	name: string;
	description: string;
}
